module.exports = __webpack_public_path__ + "img/office.5660530c.jpg";